import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'hubtiger-star-rating',
  templateUrl: './hubtiger-star-rating.component.html',
  styleUrls: ['./hubtiger-star-rating.component.scss']
})
export class HubtigerStarRatingComponent implements OnInit {

  @Input() noStars;
  @Input() rating;
  @Input() colour;
  public stars : any = []

  constructor() { }

  ngOnInit() {
    for (let i = 1; i <=  this.noStars; i++) {
      this.stars.push(i);
    }
  }

  round(value)
  {
    return Math.round(value);
  }

  isDecimal(value){
    return value % 1;
  }
}
